import type {
  CreateResult,
  DeleteResult,
  ListResult,
  ServiceContext,
} from "@prolarus/shared";
import { tryCreate, tryDelete, tryList, toQueryString } from "./_shared";

export interface GroupMemberRow {
  profile_id: string;
  created: string;
}

export interface GroupMemberAssignment {
  id: string;
  profile_id: string;
  group_id: string;
  company_id: string;
}

// _companyId / _context are kept for signature compatibility with the prior
// client-side groupMemberService. The route derives company_id and user_id
// from the JWT.
export const groupMemberService = {
  listMembers(
    groupId: string,
    _companyId: string,
  ): Promise<ListResult<GroupMemberRow>> {
    return tryList<GroupMemberRow>(
      `/api/groups/${encodeURIComponent(groupId)}/members`,
    );
  },

  addMember(
    groupId: string,
    profileId: string,
    _context: ServiceContext,
  ): Promise<CreateResult<GroupMemberAssignment>> {
    return tryCreate<GroupMemberAssignment>(
      `/api/groups/${encodeURIComponent(groupId)}/members`,
      { profile_id: profileId },
    );
  },

  removeBulkMembers(
    groupId: string,
    profileIds: string[],
    _companyId: string,
  ): Promise<DeleteResult> {
    return tryDelete(
      `/api/groups/${encodeURIComponent(groupId)}/members${toQueryString({
        profile_ids: profileIds.join(","),
      })}`,
    );
  },
};
